import { LucideShieldCheck } from 'lucide-react';
import React, { useState } from 'react';
import { Icons } from '../Icons';
import { Input } from '../Input/Input';
import { Tooltip } from '../Tooltip/Tooltip';

export type PasswordInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: string;
  hideIcon?: boolean;
};

// This input is masked, but doesn't trigger the brower's "Save this password" prompt.
// Good for confidential info like SSNs.
const MaskedInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, type, error, hideIcon = false, ...props }, ref) => {
    const [isDecoded, setIsDecoded] = useState(false);

    const ComponentForIcon = !isDecoded ? Icons.EyeOff : Icons.Eye;

    // Compose the rightEl for Input
    const rightEl = () => (
      <div className="flex items-center gap-2 pr-1">
        {!hideIcon && (
          <Tooltip content="Secure Information">
            <LucideShieldCheck className="h-5 w-5 flex items-center cursor-pointer text-accent-blue-100" />
          </Tooltip>
        )}
        <ComponentForIcon
          onClick={() => {
            setIsDecoded((prev) => !prev);
          }}
          className="flex items-center cursor-pointer text-fg-quaternary size-4"
        />
      </div>
    );

    return (
      <Input
        ref={ref}
        {...props}
        className={className}
        error={error}
        rightEl={rightEl}
        type="text" // Always render as text, masking is handled by WebkitTextSecurity
        // @ts-ignore: WebkitTextSecurity is a non-standard CSS property
        style={!isDecoded ? { WebkitTextSecurity: 'disc' } : undefined}
      />
    );
  }
);
MaskedInput.displayName = 'MaskedInput';

export { MaskedInput };
